import $ from "jquery";

let $flyoutMenu = $(".flyout-menu");
let $burgerBtn = $(".btn--burger"); //  || $header.find('.btn--burger-2')
let $header = $(".header");
let $mainNav = $header.find(".main-nav");
let prevScreenWidth = window.innerWidth;

let isFlyoutHidden = true;

function animateSVG() {
  let $cat = $(".flyout-menu__category.active");
  if ($cat.length === 0) return;
  setTimeout(function () {
    let htmlSVG = makeSVGGuide(
      $cat,
      $cat.children(".flyout-menu__list"),
      "flyout-menu__decor"
    );
    $flyoutMenu.children(".flyout-menu__decor").remove();
    $flyoutMenu.append(htmlSVG);
  }, 250);
}

/**
 * Makes <svg> HTML string as a decoration
 *
 * @param {JQuery} menu - parent menu item of fyout
 * @param {JQuery} list - child menu list, related to parent menu
 * @param {String} decorClass - class of decoration (optional)
 * @returns {String} SVG element as string
 */
function makeSVGGuide(menu, list, decorClass = "decor") {
  let liTextElem = menu.children().eq(0);
  let liElemWidth = liTextElem.outerWidth();
  let liElemHeight = liTextElem.outerHeight();
  let liElemOffset = liTextElem.offset();

  let listElemW = list.outerWidth() * 0.4;
  let listElemH = list.outerHeight();
  let listElemOffset = list.offset();

  let diff = listElemOffset.left - liElemOffset.left - liElemWidth;
  if (diff < 0) diff = 0;
  // let horizLineTop = liElemOffset.top - listElemOffset.top + liElemHeight * 0.5;
  let horizLineTop =
    liTextElem[0].offsetTop - list[0].offsetTop + liElemHeight * 0.5;

  let svgHeight = Math.max(listElemH, menu.parent().outerHeight());

  // get margin-top of flyout-menu__wrapper
  let mtop = $(".flyout-menu__wrapper").css("margin-top");
  mtop = parseInt(mtop.replace("px", ""));

  // let top = listElemOffset.top;
  let top = list[0].offsetTop + mtop;

  let html = `<svg class="${decorClass}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${
    diff + listElemW
  }px" height="${svgHeight}" viewBox="0 0 ${
    diff + listElemW
  } ${svgHeight}" xml:space="preserve" style="top:${top}px;left:${
    liElemOffset.left + liElemWidth - 2
  }px;"> <polyline class="flyout-decor-path" points="0,${horizLineTop} ${diff},${horizLineTop} ${diff},2 ${
    diff + listElemW
  },2" style="stroke-dasharray:${
    diff + horizLineTop + listElemW
  };stroke-dashoffset:${
    diff + horizLineTop + listElemW
  }" /><polyline class="flyout-decor-path" points="0,${horizLineTop} ${diff},${horizLineTop} ${diff},${
    listElemH - 2
  } ${diff + listElemW},${listElemH - 2}" style="stroke-dasharray:${
    diff + (listElemH - horizLineTop) + listElemW
  };stroke-dashoffset:${
    diff + (listElemH - horizLineTop) + listElemW
  }" /></svg>`;

  // console.log(html);
  return html;
}

const flyout = () => {
  let decorClass = "flyout-menu__decor";
  let isWideScreen = window.innerWidth > 767;

  // Method to hide mobile flyout
  const hideMobileMainNav = function () {
    $mainNav.addClass("main-nav--hidding").removeClass("show");
    setTimeout(function () {
      $mainNav.removeClass("main-nav--hidding");
    }, 500);
  };

  /**
   * Utility method to hide flyout with CSS effect
   *
   * @param {Boolean} closeMenu - indicates that the main navigation should also be closed
   * (normally when clicked) outside of the flyout
   */
  const closeFlyoutMenu = function (closeMenu) {
    if (isFlyoutHidden) return;
    $burgerBtn.removeClass("active");
    $header.removeClass("header--opened-flyout");
    $flyoutMenu.removeClass("show");
    isFlyoutHidden = true;
    if (closeMenu) {
      $mainNav.find("ul").children().removeAttr("style");
      hideMobileMainNav();
    }
  };

  /**
   * Handles click event outside of flyout menu (backdrop)
   *
   * @param {Event} e - click event
   */
  const clickOutFlyoutHandler = function (e) {
    const targetElem = $(e.target);
    if (
      targetElem.closest($flyoutMenu).length ||
      targetElem.closest($mainNav).length ||
      (targetElem.closest($header).length &&
        !$flyoutMenu.find(".flyout-menu-close").length)
    ) {
      return;
    }
    $mainNav.find("li").removeClass("active");
    $burgerBtn.removeClass("active");
    closeFlyoutMenu(true);
    $("body").off("click", clickOutFlyoutHandler);
  };

  /**
   * Activates flyout menu considering screen orientation
   *
   * @param {JQuery} menu - Flout parent menu item
   * @param {Boolean} isMobile - mobile indicator (if true, activating in different way)
   */
  const showFlyoutMenu = function (menu, isMobile) {
    isFlyoutHidden = false;
    if (isMobile) {
      $header.addClass("header--mobile-flyout");
      $flyoutMenu.addClass("show");
      menu.addClass("active");
      // return;
    }

    if (!$flyoutMenu.hasClass("show")) {
      $header.addClass("header--opened-flyout");
      $flyoutMenu.addClass("show");
      // $("body").on("click", clickOutFlyoutHandler);
    }

    // Do not complete operations if the same menu is opened
    if (menu.hasClass("active")) return;

    menu.siblings(".active").removeClass("active");
    menu.addClass("active");

    if (window.innerWidth > 991) {
      try {
        animateSVG();
      } catch (e) {
        console.warn("Error occurred while building animatable path.", e);
      }
    }
  };

  /**
   * Dispatch flyout behaviour
   * when click event of the main navigation is fired
   *
   * @param {Event} e
   */
  const flyoutEventHandler = function (e) {
    e.preventDefault();
    let $this = $(this);
    let dataMenu = $this.data("menu");

    // If no data-menu dataset, perform default action
    if (!dataMenu) {
      if ($(e.target).parents(".breadcrumbs").length > 0) {
        let txt = $(e.target).text();
        let link = $mainNav.find(`.nav-link:contains(${txt})`);
        if (link.length === 0) return;
        if (link.parent().data("menu") === undefined) return;
        $this = link.parent();
        dataMenu = link.parent().data("menu");
      } else {
        return;
      }
    }

    // Close flyout in case of attempt to activate the same link
    if (
      e.type === "click" &&
      $this.hasClass("active") &&
      $flyoutMenu.hasClass("show")
    ) {
      $this.removeAttr("style").removeClass("active");
      closeFlyoutMenu();
      return;
    }

    // Activate a new item in main navigation
    $this.siblings(".active").removeClass("active");
    $this.addClass("active");

    // Activate needed flyout group
    let menu = $flyoutMenu.find(`[data-category="${dataMenu}"]`);

    // Show flyout with category
    if (menu.length) {
      // if (!isWideScreen) {
      //   // Place flyout with category (mobile screen)
      //   $this.siblings().removeAttr('style');
      // }

      showFlyoutMenu(menu, !isWideScreen);
    } else {
      console.warn(
        `%cMenu category "${dataMenu}" is not found in flyout.`,
        warnStyle
      );
      return;
    }
  };

  // Resize event handler

  $(window).on("resize", function (e) {
    if (!e.isTrigger) {
      clearTimeout(this._sltimer);
      this._sltimer = setTimeout(() => {
        isWideScreen = window.innerWidth > 767;
        animateSVG();
      }, 250);
    }
  });

  // Attach Flyout event handlers
  $mainNav.find("li").on("click", flyoutEventHandler);

  let breadcrumbs = $(".breadcrumbs");
  if (breadcrumbs.length > 0) {
    breadcrumbs.find("li").eq(1).off().on("click", flyoutEventHandler);
  }

  $header.find('[data-js="close-flyout"]').on("click", closeFlyoutMenu);

  // Click on submenus that are commonly in flyout
  $flyoutMenu.find("[data-category]").on("click", function () {
    if (this.classList.contains("active")) {
      $(this).removeClass("active");
      $(this).children(".flyout-menu__decor").remove();
    } else {
      let $self = $(this);
      $self.siblings(".active").removeClass("active");
      $self.addClass("active");

      if (window.innerWidth > 991) {
        try {
          animateSVG();
        } catch (e) {
          console.warn("Error occurred while building animatable path.", e);
        }
      }
    }
  });

  // Back to main menu on mobile
  $flyoutMenu.find(".btn-back").on("click", function () {
    $mainNav.find(".active").removeClass("active");
    $header.removeClass("header--mobile-flyout");
    $flyoutMenu.find(".flyout-menu__category.active").removeClass("active");
    $flyoutMenu.removeClass("show");
  });

  // need to close flyout menu before leaving the page (Edge)
  let wNav = window.navigator.userAgent;
  if (
    wNav.indexOf("Edg") > -1 ||
    wNav.indexOf("Edge") > -1 ||
    wNav.indexOf("EdgiOS") > -1 ||
    wNav.indexOf("EdgA") > -1
  ) {
    $flyoutMenu.find(".nav-link").on("click", function (e) {
      e.preventDefault();
      closeFlyoutMenu();

      let href = $(this).attr("href");
      if (href === "#") return;
      window.location.href = href;
    });
  }
};

/**
 * Flyout with apps menu
 * in Hub Intranet
 *
 * @param {HTMLElement} targetLink - clicked link
 * @param {HTMLElement} header - Top <header> element (optional)
 */
const flyoutApps = (targetLink) => {
  const flyoutApps = $(".flyout-apps");

  /**
   * Handles click event outside of apps flyout menu (backdrop)
   *
   * @param {Event} e - click event
   */
  const clickOutFlyoutHandler = function (e) {
    let $targetElem = $(e.target);

    if (
      $targetElem.closest(flyoutApps).length ||
      $targetElem.closest(targetLink).length
    ) {
      return;
    }

    flyoutApps.removeClass("show");
    targetLink.removeAttr("style");

    $("body").off("click", clickOutFlyoutHandler);
  };

  targetLink.on("click", function (e) {
    e.preventDefault();

    // Activate link and flyout
    const linkOffset = $(this).offset();

    flyoutApps
      .find('[data-js="close"]')
      .css("margin-left", linkOffset.left - 20 + "px");
    flyoutApps.addClass("show");
    $("body").on("click", clickOutFlyoutHandler);
  });

  // Close button to deactivated link and flyout
  flyoutApps.find('[data-js="close"]').on("click", function (e) {
    e.preventDefault();
    flyoutApps.removeClass("show");
    $(this).removeAttr("style");
  });
};

export const init = () => {
  let attempts = 0;

  // if document.ready needed
  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;
    if (document.readyState === "complete") {
      $burgerBtn.on("click", function (e) {
        e.preventDefault();

        if ($mainNav.hasClass("show")) {
          $burgerBtn.removeClass("active");
          $mainNav.removeClass("show");
          $header.removeClass("header--mobile-flyout");
          $flyoutMenu.removeClass("show");
          $flyoutMenu
            .find(".flyout-menu__category.active")
            .removeClass("active");
          isFlyoutHidden = true;
        } else {
          $burgerBtn.addClass("active");
          $mainNav.addClass("show");
          isFlyoutHidden = false;
        }
      });

      flyout();

      if ($header.find('.header-link[data-js="apps"]')) {
        flyoutApps($header.find('.header-link[data-js="apps"]'));
      }

      // let wNav = window.navigator.userAgent;
      // if (
      //   wNav.indexOf("Edg") > -1 ||
      //   wNav.indexOf("Edge") > -1 ||
      //   wNav.indexOf("EdgiOS") > -1 ||
      //   wNav.indexOf("EdgA") > -1
      // ) {
      //   closeFlyoutMenuAtStart();
      // }
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };
  whenComplete();
};
